
import { mapGetters } from 'vuex'

// tab-ul ullar için csss bak.
export default {
  props: {
    product: {
      default: () => {
        return {
          imagePath: '',
        }
      },
    },
  },
  computed: {
    ...mapGetters({
      getActiveUser: 'user/getActiveUser',
    }),
  },
}
